import { Subject, Observable, BehaviorSubject } from 'rxjs'
import { AdditionalQualifier } from './table-state.model'
import { ExternalFilter } from './external-filter'
import { EntityData } from './entity-data'
import { take } from 'rxjs/operators'
import { SoftFilter } from './softfilter'

export class TableData {
  entityType: string
  showHeader = true
  showButtons = true
  pagination = true
  showAttachments = true
  scrollable = false
  inlineEdit = true
  toggleable = false
  dataSource: Observable<EntityData>
  scrollHeight: string
  entitySelectionDialog = false
  showSelectList = false

  private filterQualifier: ExternalFilter
  // The Subject fires whenever the external definable filters (hard filters, soft filters) are changed
  $filterQualifier: BehaviorSubject<ExternalFilter>

  triggerRefresh: Subject<unknown>

  /**
   * @param entityType Type of entity to be displayed as specified in EntityConfiguration
   */
  constructor(entityType: string) {
    this.triggerRefresh = new Subject()
    this.entityType = entityType

    this.filterQualifier = new ExternalFilter(null, null)
    this.$filterQualifier = new BehaviorSubject(this.filterQualifier)
  }

  getExternalFilterQualifier$() {
    return this.$filterQualifier.asObservable()
  }

  setFilters(hardFilter: AdditionalQualifier, softFilter: SoftFilter) {
    this.filterQualifier = new ExternalFilter(hardFilter, softFilter)
    this.$filterQualifier.next(this.filterQualifier)
    return this
  }

  /**
   * Alternative data source if the entity is not using the standard entity API
   * Only limited functionality, no support for lazy loading.
   * @param dataSource data to be displayed
   */
  setDataSource(dataSource: Observable<EntityData>) {
    this.dataSource = dataSource
    return this
  }

  /**
   * Sets scroll height on scrollable table. Needs to be set when table is scrollable.
   * If the scrollable flag has not been set the table header will be misaligned with the content.
   * @param scrollHeight maximum height of scrollable container. Needs to be of format /[0-9]+px/
   */
  setScrollHeight(scrollHeight: string) {
    this.scrollHeight = scrollHeight
    return this
  }

  /** Enables vertical and horizontal scrolling */
  setScrollable() {
    this.scrollable = true
    return this
  }

  setToggleable() {
    this.toggleable = true
    return this
  }

  hideHeader() {
    this.showHeader = false
    return this
  }

  hideButtons() {
    this.showButtons = false
    return this
  }

  hideAttachments() {
    this.showAttachments = false
    return this
  }

  disablePagination() {
    this.pagination = false
    return this
  }

  disableInlineEdit() {
    this.inlineEdit = false
    return this
  }

  isEntitySelectionDialog() {
    this.entitySelectionDialog = true
    return this
  }

  /** Displays a column with checkboxes for entity selection */
  displaySelectList() {
    this.showSelectList = true
    return this
  }
}
